(function() {
    "use strict";

    const ko = require('knockout');
    const $ = require('jquery');
    const typeahead = require('bootstrap-3-typeahead');

    ko.bindingHandlers.typeahead = {
        init: function (element, valueAccessor, allBindings) {
            let $elem = $(element);
            let options = allBindings.get('typeaheadOptions') || {};
            $elem.typeahead({
                autoSelect: options.autoSelect || true,
                display: options.display || 'display',
                delay: options.delay || 500,
                items: options.items || 10,
                name: options.name || 'name',
                source: options.source || function (query, syncResults) {
                    syncResults([]);
                }
            });
        },
        update: function (element, valueAccessor) {
            let $elem = $(element);
            let value = valueAccessor();
            $elem.change(() => {
                let current = $elem.typeahead("getActive");
                if (current && !current[0]) {
                    if (current.name.toLowerCase() === $elem.val().toLowerCase()) {
                        let result = value().find(item => {
                            return item.name.toLowerCase() === current.name.toLowerCase();
                        });
                        if (!result)
                            value.push(current);
                        $elem.val("");
                    }
                }
            });
        }
    };
})();


// WEBPACK FOOTER //
// ./resources/scripts/bindings/ko.typeahead.js